import { render } from "./AuthenticationView.vue?vue&type=template&id=4055b915&scoped=true"
import script from "./AuthenticationView.vue?vue&type=script&lang=js"
export * from "./AuthenticationView.vue?vue&type=script&lang=js"

import "./AuthenticationView.vue?vue&type=style&index=0&id=4055b915&scoped=true&lang=css"

import exportComponent from "C:\\Users\\r-shibata\\Documents\\multi-point-measurements\\env-unevenness-visualizer\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4055b915"]])

export default __exports__